<div>
  <div class="website-container">
    <div class="search-bar-wrap" [ngClass]="{
      'detail-page': pageType === pageTypes.DETAIL_PAGE,
    }">
      @for (container of layoutData?.headerContainer; track container) {
        <div class="header-section" [style]="{ 'min-height': container?.sliderMinHeight + 'px'}">
          <div class="search-bar">
            @switch (container?.component) {
              @case ('DesktopShortStaySearchFormComponent') {
                <app-b2b-shortstay-form [compData]="{
                container: container
              }">
                </app-b2b-shortstay-form>
              }
              @default {
                @if (((container?.component | b2bDynamicLoaderPipe) | async); as component; ) {
                  <ng-container *ngComponentOutlet="component; inputs: {
                      compData: {
                          container: container
                      }
                    }"/>
                }
              }
            }
          </div>
        </div>
      }
    </div>
    <ng-container *ngTemplateOutlet="contentTemplate;"></ng-container>
  </div>
</div>

<ng-template #contentTemplate>
  @if ((layoutData?.mainContainer?.length > 0)) {
    <div class="main-body">
      @for (container of layoutData?.mainContainer; track container) {
        @switch (container.component) {
          @case ('BreadCrumbComponent') {
            <div id="{{ container?.key }}" class="breadcrumb-wrap">
              <app-b2b-breadcrumb [compData]="{ container: container }"></app-b2b-breadcrumb>
            </div>
          }
          @case ('ShortPropertyCardComponent') {
            <div id="{{ container?.key }}" class="p-basic">
              <app-b2b-short-property-card
                [compData]="{ container: container, pc1: layoutData?.pc1 }"

              ></app-b2b-short-property-card>
            </div>
          }
          @case ('ImageGalleryComponent') {
            <div id="{{ container?.key }}" class="img-g">
              <app-b2b-image-gallery [compData]="{
              container: container,
              width: 355,
              height: 200
            }"
                                     [diffImageSizes]="diffImageSizes">

              </app-b2b-image-gallery>
            </div>
          }
          @case ('TabsComponent') {
            <div id="{{ container?.key }}" class="tab-component">
              <app-b2b-new-tabs
                [compData]="{ container: container }"
                (changeTab)="onChangeTab($event)"
              ></app-b2b-new-tabs>
            </div>
          }
          @case ('RowLeftRightLayoutComponent') {
            <div>
              <div class="detail-page-layout">
                <!-- left container starts -->
                <!--<div id="left-container" class="left-container" [ngStyle]="{width: (container?.colSize * 10) + '%'}">-->
                <div id="left-container" class="left-container">
                  @for (nestedContainer of container?.containers; track nestedContainer) {
                    @switch (nestedContainer?.component) {
                      @case ('InformationCardComponent') {
                        <div id="{{ nestedContainer?.key }}" class="information-card">
                          <app-activity-information-card
                            [compData]="{ container: nestedContainer }">
                          </app-activity-information-card>
                        </div>
                      }
                      @case ('RoomComponent') {
                        <div id="{{ nestedContainer?.key }}" class="rm-cmp">
                          <app-b2b-property-room-card
                            [compData]="{
                              container: nestedContainer
                             }"
                            [multiRoomWarningContainer]="layoutData?.multiRoomWarningContainer"
                            [cartContainer]="layoutData?.cartContainer"
                            [seoPageData]="layoutData?.seoPageData"
                          ></app-b2b-property-room-card>
                        </div>
                      }
                      @default {
                        <div id="{{ nestedContainer?.key }}" class="mb-cls">
                          @if (((nestedContainer?.component | b2bDynamicLoaderPipe) | async); as component) {
                            <ng-container *ngComponentOutlet="component; inputs: {
                          compData: {
                              container: nestedContainer
                          }
                        }"/>
                          }
                        </div>
                      }
                    }
                  }
                </div>
                <!-- left container ends -->
                <!-- right container starts -->
                <div id="right-container" class="right-container sticky-cart">
                  <!-- price container -->
                  <b2b-detail-page-cart [compData]="{
                containers: layoutData?.cartContainer,
                layoutData:layoutData
              }"></b2b-detail-page-cart>
                </div>
                <!-- right container ends -->
              </div>
            </div>
          }
          @default {
            <div id="{{ container?.key }}" class="mb-cls">
              @if (((container?.component | b2bDynamicLoaderPipe) | async); as component) {
                <ng-container *ngComponentOutlet="component; inputs: {
                      compData: {
                          container: container
                      }
                    }"/>
              }
            </div>
          }
        }
      }
      <div id="similar_properties_container">
        @for (similarPropertyContainer of layoutData?.similarProductsContainer; track similarPropertyContainer) {
          <div>
            @if (((similarPropertyContainer?.component | b2bDynamicLoaderPipe) | async); as component) {
              <!-- <div [appLoader]="component"
              [compData]="{container: similarPropertyContainer}"
              appB2bDynamicLoader>
            </div>-->
              <ng-container *ngComponentOutlet="component; inputs: {
                      compData: {
                          container: similarPropertyContainer
                      }
                    }"/>
            }
          </div>
        }
      </div>
    </div>
  } @else {
    @if (!skeletonKeys.errorLoaded) {
      <div class="d-sk">
        <div class="skeleton-box-header">
          <div>
            <div class="loading box-1"></div>
            <div class="loading box-2"></div>
            <div class="loading box-3"></div>
          </div>
          <div>
            <div class="loading box-4"></div>
          </div>
        </div>
        <div class="skeleton-box-grid">
          <div class="loading ig-sk"></div>
          <div class="loading ig-sk"></div>
          <div class="loading ig-sk"></div>
          <div class="loading ig-sk"></div>
          <div class="loading ig-sk"></div>
        </div>
      </div>
    }
  }
  @if (errorContainers?.length > 0) {
    @for (errorContainer of errorContainers; track errorContainer) {
      @if (((errorContainer?.component | b2bDynamicLoaderPipe) | async); as component) {
        <ng-container *ngComponentOutlet="component; inputs: {
                      compData: {
                          container: errorContainer
                      }
                    }"/>
      }
    }
  }
</ng-template>

